window.g = {
    timeOut: 8000,

    baseUrl: 'http://www.tcl-cctv.com/company/api/' , // 配置服务器地址,最后面要带 /
    imgserver: 'http://www.tcl-cctv.com/'  // 配置服务器地址,最后面要带 /

    // baseUrl: 'http://www.v6_2.com/company/api/' , // 配置服务器地址,最后面要带 /
    // imgserver: 'http://www.v6_2.com/'  // 配置服务器地址,最后面要带 /
}

